import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button, Flex } from "antd";
import { Text } from "../../Global/Atomics/Text";
import Theme from "../../../styles/Theme/Theme";
import { SelectAtomic } from "../../Global/Atomics/SelectAtomic";
import Spinner from "../../Global/Atomics/Spinner";
import CustomIcon from "../../Global/Icons/CustomIcon";
import { useGlobalFilterContext } from "../../../contexts/GlobalFilterProvider";
import { MulitpleSelectAtomic } from "../../Global/Atomics/MulitpleSelectAtomic";
import { useAuthContext } from "../../../contexts/AuthContext";

export const Filters = ({ filtersTranslate, enableApply }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [disabledEntitiesSelect, setDisabledEntitiesSelect] = useState(false);
    const [disabledSubEntitiesSelect, setDisabledSubEntitiesSelect] = useState(false);

    const [disabledApplyButton, setDisabledApplyButton] = useState(false);

    const { checkToken } = useAuthContext();
    const { dropdownEntities, dropdownSubEntities,
        entityToFetch, subEntityToFetch,
        handleSubEntitiesOptionsChange, classes, handleClassesChange,
        handleEntitiesOptionsChange, classesDropdown, typesFetching, onApplyFilters } = useGlobalFilterContext();

    // useEffect(() => {
    //     // if (subEntityToFetch) {
    //     //     setDisabledEntitiesSelect(true);
    //     //     setDisabledSubEntitiesSelect(true);
    //     // }
    //     if (classesDropdown) {
    //         setDisabledEntitiesSelect(false);
    //         setDisabledSubEntitiesSelect(false);
    //     }
    // }, [classesDropdown])

    useEffect(() => {
        if (enableApply) {
            setDisabledApplyButton(false);
        }
    }, [enableApply])

    const isEmpty = (value) => {
        // Verifica se é um array vazio
        if (Array.isArray(value) && value.length === 0) {
            return true;
        }

        // Verifica se é um objeto vazio
        if (typeof value === 'object' && value !== null && Object.keys(value).length === 0) {
            return true;
        }

        return false;
    };

    return (
        <FiltersWrapper className={isOpen ? " is-open" : null}>
            <div className="filters-header">
                <div className="filters-title">
                    <div className="filters-button " onClick={() => { setIsOpen(true) }}><CustomIcon icon={'CollapseOpen'} iconsize='sm' color={'blue-4'} /></div>
                    {isOpen ?
                        <Text textcolor='coolgray-12' marginleft='s03' textsize='text_sm' textweight='regular'>{filtersTranslate.filters}</Text> : null
                    }
                </div>
                {isOpen ?
                    <div className="filters-button" onClick={() => { setIsOpen(false) }}><CustomIcon icon={'Collapse'} iconsize='sm' color={'blue-4'} /></div> : null
                }

            </div>
            {isOpen ?
                <>
                    {/* Saved filters */}
                    {/* {console.log('savedFilters', savedFilters)} */}
                    {/* <SavedFilterContent savedFiltersData={savedFilters} openSavedFilters={openSavedFilters} isSavedFilterOpened={isSavedFilterOpened}/> */}

                    {/* Filters to save */}
                    <div className="filter-content">
                        {dropdownEntities && !isEmpty(dropdownEntities) ?
                            <div className="filter-content-item">
                                <SelectAtomic optionsData={dropdownEntities} handleOptionsChange={(value, record) => { handleEntitiesOptionsChange(record) }} defaultValue={entityToFetch?.value} fullWidth={true} isToDisable={disabledEntitiesSelect} />
                            </div>
                            :
                            <div style={{ height: '10%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}> <Spinner stroke="green-4" size='28px' /></div>
                        }
                        {isEmpty(dropdownSubEntities) ? null :
                            <div className="filter-content-item">
                                <SelectAtomic optionsData={dropdownSubEntities} handleOptionsChange={(value, record) => { handleSubEntitiesOptionsChange(record) }} defaultValue={subEntityToFetch?.value} fullWidth={true} isToDisable={disabledSubEntitiesSelect} />
                            </div>
                        }
                        {classesDropdown || (!classesDropdown && typesFetching) ?
                            !typesFetching ?
                                classesDropdown?.map((el, idx) => {
                                    const classesOptions = classes.find(x => x.name === el.name)?.options;
                                    return (
                                        <div key={idx} className="filter-content-item">
                                            {/* <ExpCollapse element={el} handleClassesChange={handleClassesChange} index={idx} /> */}
                                            <MulitpleSelectAtomic
                                                optionsData={el.options}
                                                handleOptionsChange={(placeholder, selectedlasses) => {
                                                    handleClassesChange(el.name, selectedlasses.map(x => x.value));
                                                }}
                                                defaultValue={el.options.filter(x => classesOptions?.includes(x.value)).map(x => { return { label: x.label, value: x.value } })}
                                                fullWidth={true}
                                                placeholder={el.name}
                                            />
                                        </div>
                                    )
                                })
                                : <div style={{ height: '10%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}> <Spinner stroke="green-4" size='28px' /></div>
                            : null
                        }


                        <Flex gap='middle' vertical="true" className="btn-spacing">
                            <Button disabled={disabledApplyButton || typesFetching || !classes?.find(x => x.options?.length > 0) ? true : false} shape="round" className="ant-btn-blue -small" onClick={() => {checkToken(); onApplyFilters();}}>{filtersTranslate.apply}</Button>
                            {/* } */}
                        </Flex>


                    </div>
                </>
                : null
            }
        </FiltersWrapper>
    )
}

const FiltersWrapper = styled.div.attrs({
    className: 'with-bg-color',
})`
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: ${Theme.color['neutral-2']};
    padding: ${Theme.spacing['s07']} ${Theme.spacing['s05']};
    width: auto;
    height: -webkit-fill-available; /* Doesnt work in all browsers */
    height: 100%; /* works in firefox and others browsers */

    &.is-open {
        min-width: 250px;
        width: 250px;
    }

    .filters-header{
        display: flex;
        justify-content: space-between;
        margin-bottom: ${Theme.spacing['s07']};

        .filters-title{
            display: flex;
            align-items: center;
        }
        .filters-button{
            cursor: pointer;
        }
    };

    .filter-content{
        overflow-y: auto;
        height: 100%;

        &::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 2px;
        }

        &::-webkit-scrollbar-thumb {
            background: ${Theme.color['coolgray-2']};
            border-radius: 10px;
        }
        
        .filter-content-item{
            margin-bottom: ${Theme.spacing['s07']};

            .antdSelect{
                width: 100%;

                .ant-select-arrow{
                    color: ${Theme.color['blue-4']};
                    font-size: unset;
                }

                .ant-select-selector{
                    min-height: 48px;
                    border: none;

                    .ant-select-selection-placeholder{//if mode is none need this property to center
                        align-self: center;
                    }

                    .ant-select-selection-item{//if mode is none need this property to center
                        align-self: center;
                    }
                }
            }

            .ant-picker{
                width: 100%;
                height: 48px;
                border: none;

                .ant-picker-suffix{
                    color: ${Theme.color['blue-4']};
                }
            }
        }

        .submit-content{
            display: flex;
            flex-direction: column;
            padding: 8px 0px 0px 0px;//Top padding 32px - s07 = 8px;
            
            .buttonFilter{
                border-radius: 20px;
                cursor: pointer;
                font-size: ${Theme.typography.fontSize['text_sm_desktop']};
            }
            
            .saveFilter{
                background-color: transparent;
                height: 40px;
                border-color: ${Theme.color['coolgray-2']};
                border-style: solid;
                margin-bottom: ${Theme.spacing['s05']};

                &:hover{
                    border-color: ${Theme.color['black-1']};
                    /* background-color: ${Theme.color['coolgray-4']}; */
                }

                &:focus{
                    color: ${Theme.color['black-1']};
                    background-color: ${Theme.color['white']};
                    border-color: ${Theme.color['blue-2']};
                }

                &:disabled{
                    color: ${Theme.color['black-1']};
                    background-color: #F8F8F8;
                    cursor: not-allowed;
                    border-color: ${Theme.color['coolgray-2']};
                }
            }

            .whiteButton{
                &:disabled{
                    color: ${Theme.color['coolgray-11']};
                    background-color: ${Theme.color['coolgray-2']};
                    cursor: not-allowed;
                }
            }
        }
    }
`;